import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, Mail, Clock, ArrowLeft } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';

const RegistrationSuccess = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-blue-50 to-indigo-50 flex items-center justify-center p-4">
      <div className="max-w-lg w-full">
        <Card className="shadow-xl border-0">
          <CardContent className="p-8 text-center">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <CheckCircle size={40} className="text-green-600" />
            </div>
            
            <h1 className="text-2xl font-bold text-gray-900 mb-2">
              Registration Submitted!
            </h1>
            
            <p className="text-gray-600 mb-6">
              Thank you for applying to join One Globe Alliance. Your application has been received and is now under review.
            </p>
            
            <div className="space-y-4 text-left bg-gray-50 rounded-lg p-4 mb-6">
              <div className="flex items-start space-x-3">
                <Clock size={20} className="text-blue-600 mt-0.5" />
                <div>
                  <p className="font-medium text-gray-900">Review Process</p>
                  <p className="text-sm text-gray-500">Our team will review your application within 2-3 business days.</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-3">
                <Mail size={20} className="text-blue-600 mt-0.5" />
                <div>
                  <p className="font-medium text-gray-900">Email Notification</p>
                  <p className="text-sm text-gray-500">You will receive an email once your application is approved with login credentials.</p>
                </div>
              </div>
            </div>
            
            <div>
              <Link to="/dashboard">
                <Button className="w-full bg-blue-600 hover:bg-blue-700 text-white">
                  <ArrowLeft size={18} className="mr-2" />
                  Back to Dashboard
                </Button>
              </Link>
            </div>
          </CardContent>
        </Card>
        
        <p className="text-center text-sm text-gray-500 mt-6">
          Questions? Contact us at{' '}
          <a href="mailto:info@oneglobealliance.com" className="text-blue-600 hover:underline">
            info@oneglobealliance.com
          </a>
          {' '}or{' '}
          <a href="tel:+919892105006" className="text-blue-600 hover:underline">
            +91 989-210-5006
          </a>
        </p>
      </div>
    </div>
  );
};

export default RegistrationSuccess;
